module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_pet_1.5_aq_manzana.5a80b542.png";